

























































































































import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { defineComponent } from '@vue/composition-api';
import { accessor } from '../store';

const lang = require('vuejs-datepicker/dist/locale');
const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export default defineComponent({
  data() {
    return {
      attentionText:
        '※枠内の表記について<br />' +
        'ー：「予約不可日時」、✕：「満員」、〇：「予約可能」<br />',
      show: '0',
      language: 'ja',
      languages: lang,
      openDialog: false,
      dialogItems: {
        title: '',
        text: '',
        cancelCss: '',
        okCss: '',
        cancelBtnText: '',
        okBtnText: ''
      },
      cancelCall: function () {
        this.openDialog = false;
      },
      headers: {},
      calendars: null,
      newChangeFlag: '',
      petitionType: '0',
      classObject: 'activeNew',
      //datepickerDate: '',
      reservedDate: '',
      selectStartDate: '',
      selectReservedDate: '',
      selectTimeSpot: '',
      prevBtn: true,
      nextBtn: true,
      reservedTimeSpot2: '',
      datepickerDateValue: '',
      isLoading: false
    };
  },
  mounted() {
    var that = this;
    this.newChangeFlag = this.$route.query.newChangeFlagProps;
    this.petitionType = this.$route.query.petitionTypeProps;
    var data = JSON.stringify({
      reservedDate: '',
      selectStartDate: '',
      petitionType: accessor.newPostKindValue,
      division: accessor.newPlaceKindValue,
      permissionLimit: String(accessor.newPermissionLimit),
      petitionDivision: accessor.newKindValue
    });
    this.classObject = 'activeNew';
    if (this.newChangeFlag === 'change') {
      this.classObject = 'activeChange';
      data = JSON.stringify({
        reservedDate: '',
        selectStartDate: '',
        petitionType: this.petitionType,
        division: accessor.changeInfo.petitionPlace,
        permissionLimit: String(accessor.changeInfo.permissionLimit),
        petitionDivision: accessor.changeInfo.petitionDivision
      });
    }

    var url = Vue.prototype.$API_URL + 'Choice/GetReserveFrameWeek/';
    // server側へアクセス
    axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
      .then(function (response) {
        if (response.data) {
          if (response.data.resultCode === 'FAILURE') {
            that.showMessage(response.data.resultMessage);
            return;
          }
          // 曜日を集約した配列を作成
          var itemHeaders = response.data.reserveFrameWeekItemList.filter((v1, i1, a1) => {
            return a1.findIndex((v) => v1.reservedDate === v.reservedDate) === i1;
          }).map((data) => ({ ymd: data.reservedDateDisp, week: data.reservedWeek }));

          that.selectStartDate = response.data.selectStartDate;
          that.datepickerDateValue = response.data.selectStartDate;
          that.prevBtn = response.data.prev;
          that.nextBtn = response.data.next;
          that.headers = itemHeaders;
          that.calendars = groupBy(response.data.reserveFrameWeekItemList, 'timeSpot');
          that.show = '1';
        } else {
          that.showMessage('失敗しました。');
        }
      });
  },
  computed: {
    yoyakuYmd: {
      get() {
        return accessor.newYoyakuYmd;
      },
      set(value) {
        accessor.setNewYoyakuYmd(value);
      }
    },
    datepickerDate: {
      get(): string {
        return this.datepickerDateValue;
      },
      set(value) {
        if (value !== null) {
          this.datepickerDateValue = moment(value).format('YYYY/MM/DD');
          this.reservedDate = this.datepickerDateValue;
        } else {
          this.datepickerDateValue = '';
          this.reservedDate = '';
        }
      }
    }
  },
  methods: {
    onDateChange() {
      var that = this;
      var url = Vue.prototype.$API_URL + 'Choice/GetReserveFrameWeek';
      var value = '';
      if (this.datepickerDate !== null) {
        value = moment(this.datepickerDate).format('YYYY/MM/DD');
      }
      var data = JSON.stringify({
        reservedDate: value,
        selectStartDate: '',
        petitionType: accessor.newPostKindValue,
        division: accessor.newPlaceKindValue,
        permissionLimit: String(accessor.newPermissionLimit),
        petitionDivision: accessor.newKindValue
      });
      if (this.newChangeFlag === 'change') {
        data = JSON.stringify({
          reservedDate: value,
          selectStartDate: '',
          petitionType: this.petitionType,
          division: accessor.changeInfo.petitionPlace,
          permissionLimit: String(accessor.changeInfo.permissionLimit),
          petitionDivision: accessor.changeInfo.petitionDivision
        });
      }

      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(function (response) {
          if (response.data) {
            if (response.data.resultCode === 'FAILURE') {
              that.showMessage(response.data.resultMessage);
              return;
            }
            // 曜日を集約した配列を作成
            var itemHeaders = response.data.reserveFrameWeekItemList.filter((v1, i1, a1) => {
              return a1.findIndex((v) => v1.reservedDate === v.reservedDate) === i1;
            }).map((data) => ({ ymd: data.reservedDateDisp, week: data.reservedWeek }));

            that.selectStartDate = response.data.selectStartDate;
            that.datepickerDateValue = response.data.selectStartDate;
            that.prevBtn = response.data.prev;
            that.nextBtn = response.data.next;
            that.headers = itemHeaders;
            that.calendars = groupBy(response.data.reserveFrameWeekItemList, 'timeSpot');
          } else {
            that.showMessage('失敗しました。');
          }
        });
    },
    formatter(date) {
      this.reservedDate = moment(date).format('YYYY/MM/DD');
      this.datepickerDate = moment(date).format('YYYY/MM/DD');
      return this.datepickerDate;
    },
    toReturn() {
      if (this.newChangeFlag === 'new') {
        this.$router.push('/place');
      } else {
        var that = this;
        var url = Vue.prototype.$API_URL + 'Change/GetReservedInfo';
        const data = JSON.stringify({
          reservedNum: accessor.changeInfo.reservedNum,
          petitionName: accessor.changeInfo.petitionName,
          permissionNum1: accessor.changeInfo.permissionNum1,
          permissionNum2: accessor.changeInfo.permissionNum2,
          petitionOfficer: accessor.changeInfo.petitionOfficer,
          officerType: accessor.changeInfo.officerType.join(',')
        });

        // server側へアクセス
        axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
          .then(function (response) {
            if (response.data) {
              if (response.data.resultCode === 'FAILURE') {
                that.message = response.data.resultMessage;
                return;
              }
              const info = response.data;
              that.$router.push({ path: 'change', query: { resultData: info } });
            } else {
              alert('失敗しました。');
            }
          });
      }
    },
    toPrevWeek() {
      var that = this;
      var url = Vue.prototype.$API_URL + 'Choice/GetReserveFrameWeekPrev';
      var data = JSON.stringify({
        reservedDate: this.reservedDate,
        selectStartDate: this.selectStartDate,
        petitionType: accessor.newPostKindValue,
        division: accessor.newPlaceKindValue,
        permissionLimit: String(accessor.newPermissionLimit),
        petitionDivision: accessor.newKindValue
      });
      if (this.newChangeFlag === 'change') {
        data = JSON.stringify({
          reservedDate: this.reservedDate,
          selectStartDate: this.selectStartDate,
          petitionType: this.petitionType,
          division: accessor.changeInfo.petitionPlace,
          permissionLimit: String(accessor.changeInfo.permissionLimit),
          petitionDivision: accessor.changeInfo.petitionDivision
        });
      }

      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(function (response) {
          if (response.data) {
            if (response.data.resultCode === 'FAILURE') {
              that.showMessage(response.data.resultMessage);
              return;
            }
            // 曜日を集約した配列を作成
            var itemHeaders = response.data.reserveFrameWeekItemList.filter((v1, i1, a1) => {
              return a1.findIndex((v) => v1.reservedDate === v.reservedDate) === i1;
            }).map((data) => ({ ymd: data.reservedDateDisp, week: data.reservedWeek }));

            that.selectStartDate = response.data.selectStartDate;
            that.datepickerDateValue = response.data.selectStartDate;
            that.prevBtn = response.data.prev;
            that.nextBtn = response.data.next;
            that.headers = itemHeaders;
            that.calendars = groupBy(response.data.reserveFrameWeekItemList, 'timeSpot');
          } else {
            that.showMessage('失敗しました。');
          }
        });
    },
    toNextWeek() {
      var that = this;
      var url = Vue.prototype.$API_URL + 'Choice/GetReserveFrameWeekNext';
      var data = JSON.stringify({
        reservedDate: this.reservedDate,
        selectStartDate: this.selectStartDate,
        petitionType: accessor.newPostKindValue,
        division: accessor.newPlaceKindValue,
        permissionLimit: String(accessor.newPermissionLimit),
        petitionDivision: accessor.newKindValue
      });
      if (this.newChangeFlag === 'change') {
        data = JSON.stringify({
          reservedDate: this.reservedDate,
          selectStartDate: this.selectStartDate,
          petitionType: this.petitionType,
          division: accessor.changeInfo.petitionPlace,
          permissionLimit: String(accessor.changeInfo.permissionLimit),
          petitionDivision: accessor.changeInfo.petitionDivision
        });
      }

      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(function (response) {
          if (response.data) {
            if (response.data.resultCode === 'FAILURE') {
              that.showMessage(response.data.resultMessage);
              return;
            }
            // 曜日を集約した配列を作成
            var itemHeaders = response.data.reserveFrameWeekItemList.filter((v1, i1, a1) => {
              return a1.findIndex((v) => v1.reservedDate === v.reservedDate) === i1;
            }).map((data) => ({ ymd: data.reservedDateDisp, week: data.reservedWeek }));

            that.selectStartDate = response.data.selectStartDate;
            that.datepickerDateValue = response.data.selectStartDate;
            that.prevBtn = response.data.prev;
            that.nextBtn = response.data.next;
            that.headers = itemHeaders;
            that.calendars = groupBy(response.data.reserveFrameWeekItemList, 'timeSpot');
          } else {
            that.showMessage('失敗しました。');
          }
        });
    },
    toRecentWeek() {
      var that = this;
      var url = Vue.prototype.$API_URL + 'Choice/GetReserveFrameWeekRecent';
      var data = JSON.stringify({
        reservedDate: this.reservedDate,
        selectStartDate: this.selectStartDate,
        petitionType: accessor.newPostKindValue,
        division: accessor.newPlaceKindValue,
        permissionLimit: String(accessor.newPermissionLimit),
        petitionDivision: accessor.newKindValue
      });
      if (this.newChangeFlag === 'change') {
        data = JSON.stringify({
          reservedDate: this.reservedDate,
          selectStartDate: this.selectStartDate,
          petitionType: this.petitionType,
          division: accessor.changeInfo.petitionPlace,
          permissionLimit: String(accessor.changeInfo.permissionLimit),
          petitionDivision: accessor.changeInfo.petitionDivision
        });
      }

      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(function (response) {
          if (response.data) {
            if (response.data.resultCode === 'FAILURE') {
              that.showMessage(response.data.resultMessage);
              return;
            }
            // 曜日を集約した配列を作成
            var itemHeaders = response.data.reserveFrameWeekItemList.filter((v1, i1, a1) => {
              return a1.findIndex((v) => v1.reservedDate === v.reservedDate) === i1;
            }).map((data) => ({ ymd: data.reservedDateDisp, week: data.reservedWeek }));

            that.selectStartDate = response.data.selectStartDate;
            that.datepickerDateValue = response.data.selectStartDate;
            that.prevBtn = response.data.prev;
            that.nextBtn = response.data.next;
            that.headers = itemHeaders;
            that.calendars = groupBy(response.data.reserveFrameWeekItemList, 'timeSpot');
          } else {
            that.showMessage('失敗しました。');
          }
        });
    },
    async toNext(value) {
      this.openDialog = true;
      this.selectReservedDate = value.reservedDate;
      this.selectTimeSpot = value.timeSpot;

      // 来庁用の時間帯表示のメッセージ
      var timeMessage = '';
      if (accessor.newPostKindValue === '0') {
        timeMessage = '\r\n' + '開始時間　' + value.timeSpot;
      }
      this.dialogItems.text = value.reservedDateDisp + value.reservedWeek + timeMessage + '\r\nでよろしいですか？' + '\r\n※まだ予約は確定していません。\r\nよろしければ確定ボタンを押してください';
      this.dialogItems.cancelCss = 'white';
      this.dialogItems.okCss = 'blue';
      this.dialogItems.cancelBtnText = '戻る';
      this.dialogItems.okBtnText = '確定';
      this.cancelCall = this.cancelBtn;
    },
    cancelBtn() {
      this.openDialog = false;
    },
    okBtn() {
      this.isLoading = true;
      this.openDialog = false;
      var that = this;
      var url = Vue.prototype.$API_URL + 'Comple/ValidateCompleDate';
      var data = JSON.stringify({
        reservedDate: this.selectReservedDate,
        reservedTimeSpot: this.selectTimeSpot,
        petitionType: accessor.newPostKindValue,
        petitionPlace: accessor.newPlaceKindValue,
        petitionDivision: accessor.newKindValue
      });
      if (this.newChangeFlag === 'change') {
        data = JSON.stringify({
          reservedDate: this.selectReservedDate,
          reservedTimeSpot: this.selectTimeSpot,
          petitionType: this.petitionType,
          petitionPlace: accessor.changeInfo.petitionPlace
        });
      }
      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER).then((response) => {
        if (response.data) {
          if (response.data.resultCode === 'FAILURE') {
            that.isLoading = false;
            that.showMessage(response.data.resultMessage);
            return;
          }
          if (accessor.newKindValue === '3') {
            this.reservedTimeSpot2 = response.data.reservedTimeSpot2;
          }
          if (that.newChangeFlag === 'change') {
            that.modifyDate();
          } else {
            that.saveDate();
          }
        } else {
          that.isLoading = false;
          that.showMessage('失敗しました。');
        }
      });
    },
    saveDate() {
      var url = Vue.prototype.$API_URL + 'Comple/SaveDate';
      // 予約日
      var reservedDateParma = this.selectReservedDate;
      // 予約時間帯
      var reservedTimeSpotParma = this.selectTimeSpot;
      // 申請方法
      var petitionTypeParma = accessor.newPostKindValue;
      // 申請場所
      var petitionPlaceParma = accessor.newPlaceKindValue;
      // 申請区分
      var petitionDivisionParma = accessor.newKindValue;
      // 業の区分
      var sectorParma = accessor.newSector;
      // 取扱う産業廃棄物
      var wasteHandleParma = String(accessor.newWasteHandle);
      // 申請者名
      var petitionNameParma = accessor.newSinseiName;
      // 担当者名
      var petitionOfficerParma = accessor.newTantoNameU;
      // 担当者種別
      var officerTypeParma = accessor.newCheckedTantoU;
      // 連絡先電話番号
      var contactNumberParma = String(accessor.newTantoTelU);
      // 先行許可制度
      var prePermissionSystemParma = accessor.newCheckedRiyouU;
      // 新規の場合
      if (accessor.newKindValue === '0') {
        // 業の区分
        sectorParma = accessor.newTorikindValue;
        // 取扱う産業廃棄物
        wasteHandleParma = String(accessor.newGyokindValue);
        // 申請者名
        petitionNameParma = accessor.newSinseisyaName;
        // 担当者名
        petitionOfficerParma = accessor.newTantoName;
        // 担当者種別
        officerTypeParma = accessor.newCheckedTanto;
        // 連絡先電話番号
        contactNumberParma = String(accessor.newTantoTel);
        // 先行許可制度
        prePermissionSystemParma = accessor.newCheckedRiyou;
      }
      // 許可番号1
      var permissionNum1Parma = accessor.newKyokaNo1;
      // 許可番号2
      var permissionNum2Parma = accessor.newKyokaNo2;
      // 許可の有効期限
      var permissionLimitParma = accessor.newPermissionLimit;

      const data = JSON.stringify({
        reservedDate: reservedDateParma,
        reservedTimeSpot: reservedTimeSpotParma,
        petitionType: petitionTypeParma,
        petitionPlace: petitionPlaceParma,
        petitionDivision: petitionDivisionParma,
        sector: sectorParma,
        wasteHandle: wasteHandleParma,
        petitionName: petitionNameParma,
        petitionOfficer: petitionOfficerParma,
        officerType: officerTypeParma,
        contactNumber: contactNumberParma,
        prePermissionSystem: prePermissionSystemParma,
        permissionNum1: permissionNum1Parma,
        permissionNum2: permissionNum2Parma,
        permissionLimit: permissionLimitParma,
        reservedTimeSpot2: this.reservedTimeSpot2
      });

      var that = this;
      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(function (response) {
          that.isLoading = false;
          if (response.data) {
            if (response.data.resultCode === 'FAILURE') {
              that.showMessage(response.data.resultMessage);
              return;
            }
            const info = response.data;
            that.$router.push({ path: 'comple', query: { resultData: info, classObject: 'compleNew' } });
          } else {
            that.showMessage('失敗しました。');
          }
        });
    },
    modifyDate() {
      var url = Vue.prototype.$API_URL + 'Change/ModifyDate';
      // 予約日
      var reservedDateParma = this.selectReservedDate;
      // 予約時間帯
      var reservedTimeSpotParma = this.selectTimeSpot;
      // 申請方法
      var petitionTypeParma = this.petitionType;

      const data = JSON.stringify({
        reservedNum: accessor.changeInfo.reservedNum,
        reservedDate: reservedDateParma,
        reservedTimeSpot: reservedTimeSpotParma,
        petitionType: petitionTypeParma
      });

      var that = this;
      // server側へアクセス
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(function (response) {
          that.isLoading = false;
          if (response.data) {
            if (response.data.resultCode === 'FAILURE') {
              that.showMessage(response.data.resultMessage);
              return;
            }
            const info = response.data;
            that.$router.push({ path: 'comple', query: { resultData: info, classObject: 'compleChange' } });
          } else {
            that.showMessage('失敗しました。');
          }
        });
    },
    showMessage(message) {
      this.openDialog = true;
      this.dialogItems.text = message;
      this.dialogItems.cancelCss = 'white';
      this.dialogItems.okCss = 'blue';
      this.dialogItems.cancelBtnText = '閉じる';
      this.dialogItems.okBtnText = '';
      this.cancelCall = this.cancelBtn;
    }
  }
});
